<template>
    <div>
        <div class="card card-wrapper" :style="item.available ? 'opacity: 1' : 'opacity: 0.4'" v-on="preview ? {} : { click: openItem }">
            <img class="card-img-top" :src="item.imageUrl" @error="$event.target.src='https://i.ibb.co/S5zDRCH/logo.png'" alt='Slika nije pronadjena'/>
            <div class="card-body">
                <h5 class="card-title">{{ item.name ? item.name : 'Proizvod nema naziv' }}</h5>
                <div class="card-text">
                    <h5 :style="item.discount ? 'text-decoration:line-through' : ''">
                        {{ item.price + ' RSD' }}
                    </h5>
                    <h5 style="padding-left: 5px">
                        {{ item.discount ? item.price - (item.price * item.discount / 100) + ' RSD' : '' }}
                    </h5>
                </div>
                
                <!-- Choose smell button for candles -->
                <div v-if="item.category === 'CANDLE'" class="smell-button-container">
                    <button 
                        class="smell-button" 
                        @click.stop="openItem"
                        :disabled="!item.available">
                        Izaberi miris
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import router from '@/router/'

    export default {
        name: 'ShopItem',
        props: ['item', 'preview'],
        methods: {
            openItem(e) {
                e.preventDefault()
                router.push(`/shop/item/${this.item.id}`)
            }
        }
    }
</script>

<style scoped>
    .card-wrapper {
        cursor: pointer;
    }

    .card-wrapper:hover {
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
    }

    .card-text {
        display: flex;
    }

    .smell-button-container {
        margin-top: 12px;
        text-align: center;
    }

    .smell-button {
        background: transparent;
        color: #967bb6;
        text-transform: uppercase;
        font-size: 12px;
        font-weight: bold;
        padding: 8px 16px;
        border: 1px solid #967bb6;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s ease;
        width: 100%;
    }

    .smell-button:hover:enabled {
        background: #967bb6;
        color: #ffffff;
        box-shadow: 0 2px 8px rgba(150, 123, 182, 0.3);
    }

    .smell-button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        border-color: #cccccc;
        color: #cccccc;
    }

    .smell-button:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(150, 123, 182, 0.3);
    }

    .card-title {
        font-family: "Monotype Corsiva", cursive;
        font-weight: bold;
        font-style: italic;
        font-size: 1.4em;
    }
</style>
